import type { AccountOverview, AccountOverviewResponse } from './types';

export function mapAccountOverview(data: AccountOverviewResponse): AccountOverview {
  return {
    artist: {
      id: data.artist._id,
      name: data.artist.name,
      handle: data.artist.handle,
      profileImageUrl: data.artist.profile_image_url,
      isApproved: data.artist.is_approved,
    },
    creditAccount: data.credit_account
      ? {
          id: data.credit_account._id,
          balance: data.credit_account.balance,
          totalCredits: data.credit_account.total_credits,
          allowOverages: data.credit_account.allow_overages,
        }
      : null,
    balance: data.balance,
    subscription: data.subscription
      ? {
          id: data.subscription._id,
          planId: data.subscription.plan_id,
          sku: data.subscription.sku,
          name: data.subscription.name,
          isActive: data.subscription.is_active,
          renewalDate: data.subscription.renewal_date,
          renewalPeriod: data.subscription.renewal_period,
        }
      : null,
    isEnterprise: data.is_enterprise,
  };
}
